import { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import { Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import axios from "../api/axios";
import styles from "./styles.module.css";

const LOGIN_URL = "/auth";

const navigation = [
  /*{ name: "Product", href: "#" },
  { name: "Features", href: "#" },
  { name: "Marketplace", href: "#" },
  { name: "Company", href: "#" },*/
];

const userRole = {
  Admin: 5150,
  Ent: 1984,
  User: 2001,
  Disable: 1001,
  Permit: 3600,
  Unit: 1981,
};

const Register = () => {
  const { setAuth, auth, navigate } = useAuth();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  const entID = Math.floor(Math.random() * 1000) + 1;
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phoneNumber: "",
    roles: {
      Ent: 1984,
    },
    entName: "",
    entID: entID,
  });

  const [cpass, setCpass] = useState({
    confirmpassword: "",
  });

  const handleConfirm = (event) => {
    setCpass({ [event.target.name]: event.target.value });

    //console.log(cpass.confirmpassword);
  };

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isUser, setIsuser] = useState("User");

  const userOptions = [
    { label: "User", value: "User" },
    { label: "Enterprise", value: "Enterprise" },
  ];
  const [currentYear, setCurrentYear] = useState("");

  useEffect(() => {
    const year = new Date().getFullYear();
    setCurrentYear(year.toString());
  }, []);
  const [isEnterprise, setIsEnterprise] = useState(false);

  function handleUserChange(event) {
    const selectedValue = event.target.value;
    setIsuser(selectedValue);

    if (selectedValue === "Enterprise") {
      setIsEnterprise(true);
    } else {
      setIsEnterprise(false);
    }
  }

  const [price, setPrice] = useState(null);
  const nentID = 0;

  useEffect(() => {
    // Fetch the price on component mount
    const fetchPrice = async () => {
      try {
        const response = await axios.get(`/price/${nentID}`);
        if (response.data.success) {
          setPrice(response.data.message.price);
        } else {
          console.error("Failed to fetch the price");
        }
      } catch (error) {
        console.error("Error fetching the price:", error);
      }
    };

    fetchPrice();
  }, []);

  useEffect(() => {
    if (
      data.firstName.length > 0 &&
      data.lastName.length > 0 &&
      data.email.length > 0 &&
      data.phoneNumber.length > 0 &&
      data.password.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [data]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setButtonDisabled(true);
    setError("");
    setMsg("");

    if (cpass.confirmpassword !== data.password) {
      setError("Passwords does not match");
    } else {
      let postData = { ...data };

      if (isUser === "User") {
        postData.roles = {
          User: 2001,
        };
        delete postData.entID;
        delete postData.entName;
        try {
          const response = await axios.post("/register", postData);
          //console.log(response);
          if (response) {
            setMsg(response.data.message);

            setData({
              firstName: "",
              lastName: "",
              email: "",
              password: "",
              phoneNumber: "",
              roles: {
                Ent: 1984,
              },
              entName: "",
              entID: entID,
            });
            setError("");
          } else {
            setError(response.data.error);
            setMsg("");
          }
        } catch (error) {
          if (
            error.response &&
            error.response.status >= 400 &&
            error.response.status <= 500
          ) {
            setError(error.response.data.message);
          }
          setMsg("");
        }
      } else {
        postData = {
          ...postData,
          price: price,
        };
        //const result = await axios.post("/price", priceData);
        try {
          const response = await axios.post("/registere", postData);
          //console.log(response);
          if (response) {
            setMsg(response.data.message);

            setData({
              firstName: "",
              lastName: "",
              email: "",
              password: "",
              phoneNumber: "",
              roles: {
                Ent: 1984,
              },
              entName: "",
              entID: entID,
            });
            setError("");
          } else {
            setError(response.data.error);
            setMsg("");
          }
        } catch (error) {
          if (
            error.response &&
            error.response.status >= 400 &&
            error.response.status <= 500
          ) {
            setError(error.response.data.message);
          }
          setMsg("");
        }
      }
    }
    setIsSubmitting(false);
    setButtonDisabled(false);
  };

  function PrivacyModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
        <div className="bg-white p-5 rounded-lg shadow-lg relative max-w-lg w-full mx-auto">
          {" "}
          {/* Adjust width as needed */}
          <h2 className="text-lg font-bold">Privacy Policy</h2>
          <div className="privacy-policy-content overflow-y-auto max-h-[80vh]">
            {" "}
            {/* Set maximum height and make it scrollable */}
            {/* Your privacy policy content goes here */}
            <p>
              <strong>Effective Date:</strong> 1st January, 2025
            </p>
            <p>
              Welcome to <em>Bverify</em>. We are committed to protecting your
              privacy and ensuring that your information is handled securely and
              responsibly. This Privacy Policy outlines how we collect, use, and
              safeguard your data when you use our identity verification
              platform. By using our services, you agree to the practices
              described in this Privacy Policy.
            </p>
            <h2>1. Information We Collect</h2>
            <p>
              We collect information necessary to perform identity verification,
              including but not limited to:
            </p>
            <ul>
              <li>
                Personal Identifiable Information (PII) such as name, address,
                date of birth, and identification documents.
              </li>
              <li>Verification data submitted by authorized individuals.</li>
            </ul>
            <h2>2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>
                Verify identities and confirm the authenticity of submitted
                data.
              </li>
              <li>
                Provide a secure and efficient identity verification process.
              </li>
              <li>Comply with applicable laws and regulations.</li>
            </ul>
            <h2>3. Responsibilities of the Verifier</h2>
            <p>
              Individuals or entities initiating a verification request
              (“Verifier”) are accountable for the following:
            </p>
            <ul>
              <li>
                <strong>Authorization:</strong> The Verifier warrants that they
                are authorized to perform the verification and have obtained all
                necessary consents from the individual whose identity is being
                verified.
              </li>
              <li>
                <strong>Accountability:</strong> The Verifier is solely
                responsible for ensuring the verification is conducted in
                accordance with all applicable laws and regulations.
              </li>
              <li>
                <strong>Accuracy:</strong> The Verifier is responsible for the
                accuracy and legitimacy of the information they provide during
                the verification process.
              </li>
            </ul>
            <blockquote>
              <strong>Caveat:</strong> Any misuse of the platform, unauthorized
              access, or breach of privacy caused by the Verifier will result in
              full accountability. The Verifier agrees to indemnify and hold{" "}
              <em>[Your Platform Name]</em> harmless from any liability arising
              from such actions.
            </blockquote>
            <h2>4. Data Security</h2>
            <p>
              We implement industry-standard measures to protect your data,
              including encryption, access controls, and regular audits.
              However, the Verifier must ensure the confidentiality and security
              of the data they access during the verification process.
            </p>
            <h2>5. Sharing of Information</h2>
            <p>
              We do not share personal information with third parties except
              when:
            </p>
            <ul>
              <li>Required by law.</li>
              <li>Necessary for the completion of the verification process.</li>
            </ul>
            <h2>6. Rights of Individuals</h2>
            <p>Verified individuals have the right to:</p>
            <ul>
              <li>Access the information held about them.</li>
              <li>Request corrections to any inaccuracies.</li>
              <li>Withdraw consent for future verifications.</li>
            </ul>
            <h2>7. Changes to this Privacy Policy</h2>
            <p>
              We reserve the right to update this Privacy Policy at any time.
              All changes will be communicated through updates on our platform.
            </p>
            <h2>8. Contact Us</h2>
            <p>
              For questions or concerns about this Privacy Policy, please
              contact us at:
            </p>
            <ul>
              <li>
                <strong>Email:</strong> info@ficoven.com
              </li>
            </ul>
            <p>
              By using our platform, you acknowledge and agree to this Privacy
              Policy and accept full responsibility for your actions as a
              Verifier.
            </p>
          </div>
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-lg font-bold"
          >
            &times; {/* Close Icon */}
          </button>
        </div>
      </div>
    );
  }

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (event) => {
    event.preventDefault();
    setIsModalOpen(true);
  };

  const closeModal = (event) => {
    event.preventDefault(); // This will prevent the default action of the event
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="relative isolate bg-white">
        <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2">
          <div className="relative px-6 pb-20 pt-16 sm:pt-20 lg:static lg:px-8 lg:py-36">
            <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
              <div className="absolute inset-y-0 left-0 -z-10 w-full overflow-hidden bg-gray-100 ring-1 ring-gray-900/10 lg:w-1/2">
                <svg
                  className="absolute inset-0 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
                      width={200}
                      height={200}
                      x="100%"
                      y={-1}
                      patternUnits="userSpaceOnUse"
                    >
                      <path d="M130 200V.5M.5 .5H200" fill="none" />
                    </pattern>
                  </defs>
                  <rect
                    width="100%"
                    height="100%"
                    strokeWidth={0}
                    fill="white"
                  />
                  <svg
                    x="100%"
                    y={-1}
                    className="overflow-visible fill-gray-50"
                  >
                    <path d="M-470.5 0h201v201h-201Z" strokeWidth={0} />
                  </svg>
                  <rect
                    width="100%"
                    height="100%"
                    strokeWidth={0}
                    fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)"
                  />
                </svg>
              </div>
              <img
                src="/images/logo.png"
                alt="My Image"
                width={120}
                height={20}
              />

              <div className="border-t-4 border-b-4 border-blue-500 p-4 mt-4">
                <p>
                  <img src="images/banner.png" />
                </p>
                <p className="mt-6 text-lg leading-8 text-gray-600">
                  Welcome to <em>Bverify</em> an identity verification platform!
                  We empower businesses and individuals by ensuring authenticity
                  through reliable identity and information verification.
                </p>
              </div>
            </div>
          </div>
          <form
            onSubmit={handleSubmit}
            className="px-6 pb-24 pt-20 sm:pb-32 lg:px-8 lg:py-48 "
          >
            <div className="mx-auto max-w-xl lg:mr-0 lg:max-w-lg ">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                Sign up
              </h2>
              <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                <div>
                  <label
                    htmlFor="first-name"
                    className="block text-base font-semibold leading-6 text-gray-900"
                  >
                    First name
                  </label>
                  <div className="mt-2.5">
                    <input
                      type="text"
                      name="firstName"
                      onChange={handleChange}
                      value={data.firstName}
                      id="firstname"
                      autoComplete="first-name"
                      placeholder="First Name"
                      required
                      className="block w-full rounded-md border-0 px-4 py-3 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="last-name"
                    className="block text-base font-semibold leading-6 text-gray-900"
                  >
                    Last name
                  </label>
                  <div className="mt-2.5">
                    <input
                      type="text"
                      name="lastName"
                      onChange={handleChange}
                      value={data.lastName}
                      id="lastname"
                      autoComplete="last-name"
                      placeholder="Last Name"
                      required
                      className="block w-full rounded-md border-0 px-4 py-3 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
                    />
                  </div>
                </div>
                <div className="">
                  <label
                    htmlFor="email"
                    className="block text-base font-semibold leading-6 text-gray-900"
                  >
                    Email
                  </label>
                  <div className="mt-2.5">
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      value={data.email}
                      id="email"
                      autoComplete="email"
                      placeholder="Email"
                      required
                      className="block w-full rounded-md border-0 px-4 py-3 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="phone-number"
                    className="block text-base font-semibold leading-6 text-gray-900"
                  >
                    Phone Number
                  </label>
                  <div className="mt-2.5">
                    <input
                      type="tel"
                      name="phoneNumber"
                      onChange={handleChange}
                      value={data.phoneNumber}
                      id="phoneNumber"
                      autoComplete="tel"
                      placeholder="Phone Number"
                      required
                      className="block w-full rounded-md border-0 px-4 py-3 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
                    />
                  </div>
                </div>

                <div className="mt-2.5 password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    onChange={handleChange}
                    value={data.password}
                    id="password"
                    autoComplete="password"
                    placeholder="Password"
                    required
                    className="block w-full rounded-md border-0 px-4 py-3 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
                  />
                  <div
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? "🙈" : "👀"}
                  </div>
                </div>
                <div className="mt-2.5 password-wrapper">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmpassword"
                    onChange={handleConfirm}
                    value={cpass.confirmpassword}
                    id="password"
                    autoComplete="password"
                    placeholder="Confirm Password"
                    required
                    className="block w-full rounded-md border-0 px-4 py-3 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
                  />
                  <div
                    className="password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? "🙈" : "👀"}
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="role"
                    className="block text-base font-semibold leading-6 text-gray-900"
                  >
                    Register as
                  </label>
                  <div className="mt-2.5">
                    <select
                      name="user"
                      id="user"
                      onChange={handleUserChange}
                      value={isUser}
                      className="block w-full rounded-md border-0 px-4 py-3 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
                    >
                      {userOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {isEnterprise && (
                  <div>
                    <label
                      htmlFor="entName"
                      className="block text-base font-semibold leading-6 text-gray-900"
                    >
                      Enterprise Name
                    </label>
                    <div className="mt-2.5">
                      <input
                        type="text"
                        name="entName"
                        onChange={handleChange}
                        value={data.entName}
                        id="enterprisename"
                        autoComplete="enterprise-name"
                        placeholder="Enterprise Name"
                        required
                        className="block w-full rounded-md border-0 px-4 py-3 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-base sm:leading-6"
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="pt-4">
                {error && (
                  <div className={"w-full px-2 " + styles.error_msg}>
                    {error}
                  </div>
                )}
                {msg && (
                  <div className={"w-full px-2 " + styles.success_msg}>
                    {msg}
                  </div>
                )}
              </div>
              <div className="mt-8 flex justify-end">
                <button
                  type="submit"
                  disabled={buttonDisabled}
                  className="w-full rounded-md px-4 py-3 text-center text-lg font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 hover-blue"
                >
                  {isSubmitting ? "Registering..." : "Register"}
                </button>
              </div>
              <p className="mt-3 text-sm/6 text-gray-600">
                By clicking 'Submit,' you agree to the terms and conditions
                outlined in our{" "}
                <NavLink
                  to="#"
                  onClick={openModal}
                  className="font-semibold main-text"
                >
                  Privacy Policy/Terms of Service
                </NavLink>{" "}
                of this website
              </p>
              <div className="border-t-4 border-b-4 border-blue-500 p-4 mt-4">
                {/* Navigation Bar */}
                <nav className=" flex justify-center space-x-8">
                  <NavLink to="/login">
                    <span className="cursor-pointer text-lg font-semibold text-gray-900 new-text">
                      Login
                    </span>
                  </NavLink>
                  <NavLink to="#" onClick={openModal}>
                    <span className="cursor-pointer text-lg font-semibold text-gray-900 new-text">
                      Privacy
                    </span>
                  </NavLink>
                </nav>
              </div>
            </div>
          </form>
        </div>
      </div>
      <PrivacyModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Register;
